import * as React from 'react';
import { Button } from './button';
export function ListingItem(_a) {
    var item = _a.item;
    var handleClick = function () {
        window.location.href = item.linkUrl;
    };
    return (React.createElement("div", { className: 'autonet-news-item autonet-listing-item' },
        React.createElement("div", { className: 'listing-image', style: { backgroundImage: "url(".concat(item.imgPath, ")") } }),
        React.createElement("div", { className: 'listing-text' },
            React.createElement("div", { className: 'autonet-tag' }, item.dateString),
            React.createElement("h3", null, item.title),
            React.createElement(Button, { style: 'text-like', label: item.linkLabel, title: item.title, onClick: handleClick, alignment: 'align-left' }))));
}
